"use client";
import { motion } from "framer-motion";
import { itemVariants } from "./motion";
import { useNavigate } from "react-router-dom";
import { MdVisibility } from "react-icons/md";

export default function LeadTypes({ leads }) {
  const navigate = useNavigate();

  const handleViewLeadType = (visaType) => {
    navigate(`/agent/leads?visaCategory=${encodeURIComponent(visaType)}`, {
      state: { 
        selectedCategory: visaType,
        value: "All Applications"
      } 
    });
  };

  return (
    <motion.div
      variants={itemVariants}
      className="bg-white p-6 rounded-lg shadow-customHigh w-full h-max"
    >
      <h2 className="text-lg font-medium mb-4">Types of Leads</h2>

      {leads && (
        <div className="space-y-3">
          {Object.entries(leads).map(([name, value]) => (
            <div key={name} className="relative">
              <div className="flex justify-between items-center bg-[#87CA60] text-black p-2 rounded-md hover:bg-[#7ab94e] transition-colors group">
                <div className="flex-1">
                  <span className="font-medium">{name}</span>
                  <span className="ml-2 text-sm">({value})</span>
                </div>
                <button
                  onClick={() => handleViewLeadType(name)}
                  className="bg-[#005787] text-white px-3 py-1 rounded-full hover:bg-[#004a71] transition-colors flex items-center gap-1 text-sm"
                  title="View this lead type"
                >
                  <span>View</span>
                </button>
              </div>
            </div>
          ))}
          {Object.entries(leads).length === 0 && (
            <p className="text-red-500 pt-5 text-center">No Leads</p>
          )}
        </div>
      )}
    </motion.div>
  );
}
